import { IjobSignature } from '../models';
import { SignatureTypeEnum } from '../models-enums';

// The offline queue cannot persist FormData, so a queued ADD_JOB_SIGNATURE is rebuilt from the
// signature record before it is sent; every field the API reads has to be appended here.
export const appendSignatureFields = (formData: FormData, signature: IjobSignature): FormData => {
    formData.append('id', signature.id);
    formData.append('jobID', signature.jobID);
    formData.append('SignatureType', SignatureTypeEnum[signature.signatureType] || '');
    formData.append('SignedBy', signature.signedBy || '');
    formData.append('SignedDate', signature.signedDate || '');
    formData.append('SignedByPosition', signature.signedByPosition || '');
    formData.append('Email', signature.email || '');
    if (signature.contactID) {
        formData.append('ContactID', signature.contactID);
    }
    return formData;
};
